
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./Flare.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import { ProcessContext } from "../context/ProcessContext";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import FlareStackFlame from "../components/FlareStackFlame";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import { trackPageVisit } from "../competency/PageTracker"; 
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}



function Flare() {

        useEffect(() => {
  
    trackPageVisit("Flare");
  
  }, []);

   const {  valves, toggleValve, } = useContext(WellContext);

       const { pumpData } = useContext(PumpContext);
   
const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);
  


  const DEFAULT_VALVES = {
  FCV_4101: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Flare_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_4101: { ...DEFAULT_VALVES.FCV_FCV_4101, ...parsed.FCV_4101 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Flare_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};




  // ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
            const { transmitters,  } = usePlantStore();
            const FIC_3207 = transmitters.FIC_3207 || 0;
            const FIC_3208 = transmitters.FIC_3208 || 0;







// ================= VALVE AND PUMPS INITIALIZATION AND STATUS =================
  const isXV4101Open = valves?.XV_4101 === false;
  const isXV4102Open = valves?.XV_4102 === false;
  const isXV4103Open = valves?.XV_4103 === false;

  const isP4101AOn = pumpData?.["P-4101A"]?.running ?? false;
  const isP4101BOn = pumpData?.["P-4101B"]?.running ?? false; 



  // ================= INFLOW LOGIC from TEST, FIRST STAGE, SECOND AND THIRD STAGE SEPARATOR to OILY WATER TANK LEVEL TRANSMITTER =================
     
    const FIC_4101 = isXV4102Open ? 6.987 : 0;
    
    const PT_4101 = isXV4102Open ? 0.987 : 0.03;

    const FIC_4102 = isXV4101Open ? FIC_4101 + FIC_3207 + FIC_3208 : 0;

    const PT_4102 = isXV4101Open ? 1.3 : 0.03;
    const PT_4103 = isXV4101Open ? PT_4102*0.978 : 0.03;
    
    const FIC_4103 = FIC_4102 * 0.90;

    const FIC_4105 = isXV4103Open ? 0.334 : 0;



    
                  useEffect(() => {
                      localStorage.setItem("FIC_4103", FIC_4103);
                    }, [FIC_4103]); 







    
  // ================= MAIN CORROSION INHIBITION INJECTION PUMPS =================
  const runningPumps4101 = [isP4101AOn, isP4101BOn].filter(Boolean).length;


// ================= SUCTION INPUTS =================
const suctionFlow4101 = 0;
const suctionPressure4101 = 0;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_4101 = 1.2;
const MIN_DISCH_PRESSURE_4101 = 0.03;

// ================= TARGET CALCULATIONS =================
let targetPT_4104 = MIN_DISCH_PRESSURE_4101;
let targetFIC_4104 = 0;

if (runningPumps4101 > 0) {

  // 🔹 Flow boost
  targetFIC_4104 = 10;

  // 🔹 Pressure rises to design max
  targetPT_4104 = MAX_DISCH_PRESSURE_4101;

}

// ================= STATES =================
const [PT_4104, setPT_4104] = useState(() => {
  return Number(localStorage.getItem("PT_4104")) || 0.03;
});

const [FIC_4104, setFIC_4104] = useState(() => {
  return Number(localStorage.getItem("FIC_4104")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_4104(prev => {
      const next = prev + (targetPT_4104 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_4104(prev => {
      const next = prev + (targetFIC_4104 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_4104, targetFIC_4104]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_4104", PT_4104);
}, [PT_4104]);

useEffect(() => {
  localStorage.setItem("FIC_4104", FIC_4104);
}, [FIC_4104]);

// ================= LOAD SHARING (OPTIONAL DISPLAY) =================
const loadShare2951 =
  runningPumps4101 > 0 ? (100 / runningPumps4101).toFixed(0) : 0;

// Example (if you want to display per pump later):
const pumpAFlow =
  isP4101AOn && runningPumps4101 > 0
    ? FIC_4104 / runningPumps4101
    : 0;

const pumpBFlow =
  isP4101BOn && runningPumps4101 > 0
    ? FIC_4104 / runningPumps4101
    : 0;







  return (
    <div className="Flare-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "260px",
        color: "white",
        background: "rgba(30, 6, 245, 0.97)", 
        padding: "2px 305px"
      }}>
        FLARE
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-4101 */}
      <Valve
        className="XV-4101"
        tag="XV_4101"
        x={128}
        y={172}
        isClosed={valves.XV_4101}
        toggle={toggleValve}
      />

      {/* XV-4102 */}
      <Valve
        className="XV-4102"
        tag="XV_4102"
        x={689}
        y={98}
        isClosed={valves.XV_4102}
        toggle={toggleValve}
      />

      {/* XV-4103 */}
      <Valve
        className="XV-4103"
        tag="XV_4103"
        x={475}
        y={571}
        isClosed={valves.XV_4103}
        toggle={toggleValve}
      />

      
      

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= TRANSMITTERS OUTPUTS ================= */}

  
      <Transmitter
          tag="FIC-4101"
          value={[FIC_4101]}
          x={497}
          y={89}
          unit="SCF/S"
          max={20}
          HH={15}
          H={5}
          L={1}
          LL={0.5}
          c="lime"
          description="FLOWRATE OF LEAN GAS FROM LEAN GAS SUPPLY HEADER"
        />
      <Transmitter
          tag="FIC-4102"
          value={[FIC_4102]}
          x={258}
          y={157}
          unit="SCF/S"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF GASES FROM FLARE HEADER TO FLARE KNOCK-OUT DRUM"
        />
      <Transmitter
          tag="FIC-4103"
          value={[FIC_4103]}
          x={945}
          y={292}
          unit="SCF/S"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF GASES FROM FLARE KNOCK-OUT DRUM TO FLARE STACK FOR BURNING"
        />
      <Transmitter
          tag="FIC-4104"
          value={[FIC_4104]}
          x={888}
          y={473}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF RECOVERED LIQUID FLUID FROM KNOCKOUT DRUM TO OILY WATER TANK (CLOSE DRAIN)"
        />
      <Transmitter
          tag="FIC-4105"
          value={[FIC_4105]}
          x={1122}
          y={473}
          unit="SCF/S"
          max={2}
          HH={1.5}
          H={1}
          L={0.1}
          LL={0.05}
          c="lime"
          description="FLOWRATE OF LIQUIFIED PETROLUEM GAS (LPG) USED FOR PILOT IGNITION OF FLARE"
        />

     
      <Transmitter
          tag="PT-4101"
          value={[PT_4101]}
          x={347}
          y={89}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.2}
          LL={0.05}
          c="lime"
          description="PRESSURE OF LEAN GAS FROM LEAN GAS SUPPLY HEADER"
        />
      <Transmitter
          tag="PT-4102"
          value={[PT_4102]}
          x={168}
          y={157}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.2}
          LL={0.05}
          c="lime"
          description="PRESSURE OF GASES FROM FLARE HEADER TO FLARE KNOCK-OUT DRUM"
        />
      <Transmitter
          tag="PT-4103"
          value={[PT_4103]}
          x={365}
          y={200}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.2}
          LL={0.05}
          c="lime"
          description="PRESSURE OF FLARE KNOCK-OUT DRUM"
        />
      <Transmitter
          tag="PT-4104"
          value={[PT_4104]}
          x={880}
          y={398}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.2}
          LL={0.05}
          c="lime"
          description="PRESSURE OF RECOVERED LIQUID FLUID FROM KNOCKOUT DRUM TO OILY WATER TANK (CLOSE DRAIN)"
        />




        <Pump
        tag="P-4101A"
        x={748}
        y={387}
        rpm={1800}
        bladeCount={pumpData?.["P-4101A"]?.bladeCount || 6}
        size={pumpData?.["P-4101A"]?.size || 44}
        onClick={openPumpPanel}
      />
        <Pump
        tag="P-4101B"
        x={745}
        y={484}
        rpm={1800}
        bladeCount={pumpData?.["P-4101B"]?.bladeCount || 6}
        size={pumpData?.["P-4101B"]?.size || 48}
        onClick={openPumpPanel}
      />


    <LevelTransmitterIndicator
      tag="LT_4101"
      totalLevel={200000}
      inflows={[FIC_4102 * 0.1]}
      outflows={[FIC_4104]}
      responseFactor={0.05}
      columnX={192}
      columnY={250}
      columnWidth={388}
      columnHeight={111}
      textX={621}
      textY={258}
      showFlow={true}
      backgroundOpacity={0.1}
      liquidOpacity={0.9}
      service="lpg"
    />


    <FlareStackFlame
      FIC_4105={FIC_4105}
      FIC_4101={FIC_4101}
      FIC_4103={FIC_4103}
      isXV4103Open={!valves.XV_4103}
      isXV4102Open={!valves.XV_4102}
      x={1186}
      y={-60}
    />
        



    </div>
  );
}


export default Flare;